import qs from 'qs'
import ApiService from './ApiService'

const resourceUrl = `${ApiService.prefix}rest/data/geo`

export default {
  get(mapElementId, componentFiltersParam) {
    const queryParams = {
      mapElementId,
      relCompId: componentFiltersParam.relCompIds,
      relAttrId: componentFiltersParam.relAttrIds,
      relAttrValue: componentFiltersParam.relAttrValues,
    }
    return ApiService.get(`${resourceUrl}/pins`, {
      params: queryParams,
      paramsSerializer: (params) => qs.stringify(params, { indices: false }),
    })
  },
  getMapConfig(dashboardMapId) {
    return ApiService.get(`${resourceUrl}/mapConfig/?dashboardMapId=${dashboardMapId}`)
  },
  getSummary(uid, type) {
    return ApiService.get(`${resourceUrl}/summary/${uid}?type=${type}`)
  },
}
